import PropTypes from 'prop-types'
import React, {useEffect} from 'react'

import {getKeyrusAiContent} from 'helpers/keyrusAiContent'
import {markKeyrusAiSeen} from 'helpers/keyrusAi'
import KeyrusAiAbout from 'components/KeyrusAiAbout'
import KeyrusAiContact from 'components/KeyrusAiContact'
import KeyrusAiEras from 'components/KeyrusAiEras'
import KeyrusAiHero from 'components/KeyrusAiHero'
import KeyrusAiHom from 'components/KeyrusAiHom'
import KeyrusAiNav from 'components/KeyrusAiNav'
import KeyrusAiVideoIntro from 'components/KeyrusAiVideoIntro'
import useIsMobile from 'hooks/useIsMobile'

const KeyrusAiLandingContent = ({nodeLocale, salesforceCountry}) => {
  const isMobile = useIsMobile()
  const content = getKeyrusAiContent(nodeLocale)

  useEffect(() => {
    // Seeing the AI intro — in the gateway modal OR on the standalone /keyrus-ai
    // page — counts as "seen once this session", so continuing to the site does
    // not re-trigger the gateway modal on the next (normal) page.
    markKeyrusAiSeen()
  }, [])

  return (
    <>
      <KeyrusAiVideoIntro isMobile={isMobile} nodeLocale={nodeLocale} />
      <KeyrusAiNav copy={content.nav} />
      <KeyrusAiHero copy={content.hero} isMobile={isMobile} />
      <KeyrusAiAbout copy={content.about} isMobile={isMobile} />
      <KeyrusAiHom copy={content.hom} />
      <KeyrusAiEras copy={content.eras} />
      <KeyrusAiContact
        copy={content.contact}
        salesforceCountry={salesforceCountry}
      />
    </>
  )
}

KeyrusAiLandingContent.propTypes = {
  nodeLocale: PropTypes.string,
  salesforceCountry: PropTypes.string,
}

KeyrusAiLandingContent.defaultProps = {
  nodeLocale: 'en-US',
  salesforceCountry: '',
}

export default KeyrusAiLandingContent
